export default __webpack_public_path__ + "static/media/avatar_4.c43ffe9b.svg";